import { ButtonLink } from "../../ui/ButtonLink";
import type { ProjectCarouselEntry } from "../../../data/projects";
import { Link } from "react-router-dom";
import { ProjectsCounter } from "./ProjectsCounter";

type ProjectsInfoPanelProps = {
  current: number;
  project: ProjectCarouselEntry;
  total: number;
};

export function ProjectsInfoPanel({ current, project, total }: ProjectsInfoPanelProps) {
  const releaseYear = "2024";

  return (
    <article
      aria-live="polite"
      className="projects-infoPanel"
      data-project-animate="card"
    >
      <div className="projects-infoPanel__inner">
        <div className="projects-infoPanel__mobileHeader">
          <div className="projects-infoPanel__categoryPill">{project.category}</div>
          <ProjectsCounter className="projects-infoPanel__counter" current={current} total={total} />
        </div>

        <div className="projects-infoPanel__content">
          <p className="projects-infoPanel__strapline">{project.strapline}</p>
          <h2>{project.title}</h2>
          <p className="projects-infoPanel__description">{project.description}</p>
        </div>

        <div className="projects-infoPanel__actions">
          <ButtonLink className="projects-infoPanel__cta" to={`/`}>
            Explore project
            <span aria-hidden="true">→</span>
          </ButtonLink>
          <Link className="projects-infoPanel__roundAction" to={`/`} aria-label={`View ${project.title}`}>
            <span aria-hidden="true">→</span>
          </Link>
        </div>

        <div className="projects-infoPanel__metrics">
          <div className="projects-infoPanel__metric" key="category">
            <p>Category</p>
            <strong>{project.category}</strong>
          </div>
          <div className="projects-infoPanel__metric" key="year">
            <p>Year</p>
            <strong>{releaseYear}</strong>
          </div>
        </div>
      </div>
    </article>
  );
}
